export default __webpack_public_path__ + "static/media/demo-homepage-cover.665cbb14.png";